// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand: #4a6cf7;
  --brand-dark: #3a59d0;
  --bg-light: #f7f9fc;
  --text: #1a1a2e;
  --muted: #555;
  --shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* === Контейнер === */
.AdminDashboard_dashboard__ywjs4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--bg-light);
  color: var(--text);
  padding: 2rem 1.5rem 4rem;
}

/* === Заголовок === */
.AdminDashboard_header__lCQjd {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 1200px;
  width: 100%;
  margin-bottom: 2rem;
}

.AdminDashboard_headerIcon__6DkZW {
  font-size: 2.2rem;
  color: var(--brand);
  background-color: rgba(74, 108, 247, 0.1);
  border-radius: 0.8rem;
  padding: 0.7rem;
}

.AdminDashboard_headerText__1Cv5n {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.AdminDashboard_headerText__1Cv5n h1 {
  font-size: 1.7rem;
  margin: 0;
  font-weight: 600;
}

.AdminDashboard_headerText__1Cv5n p {
  color: var(--muted);
  margin: 0.2rem 0 0;
  font-size: 0.95rem;
}

/* === Секции === */
.AdminDashboard_section__ZSL7z {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto 2.5rem;
}

.AdminDashboard_sectionTitle__bEb5h {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--brand);
  margin-bottom: 1.2rem;
  text-align: left;
}

/* === Сетка карточек === */
.AdminDashboard_cards__DM79p {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

/* === Карточка === */
.AdminDashboard_card__czI3p {
  background: #fff;
  border-radius: 0.8rem;
  padding: 1rem 1.2rem;
  color: var(--text);
  text-decoration: none;
  box-shadow: var(--shadow);
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  min-height: 90px;
  cursor: grab;
}

.AdminDashboard_card__czI3p:active {
  cursor: grabbing;
}

.AdminDashboard_card__czI3p:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.12);
}

.AdminDashboard_cardIcon__tF6Ro {
  font-size: 1.6rem;
  color: var(--brand);
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.AdminDashboard_cardText__Miycl {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.AdminDashboard_cardText__Miycl h4 {
  font-size: 1rem;
  margin: 0;
  font-weight: 600;
}

.AdminDashboard_desc__4vOmv {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 0.3rem;
  line-height: 1.3;
}

/* === Пустой раздел === */
.AdminDashboard_empty__ALdQz {
  text-align: center;
  color: var(--muted);
  padding: 2rem;
  font-size: 0.95rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0.8rem;
  border: 1px dashed rgba(0, 0, 0, 0.1);
}

/* === Адаптив === */
@media (max-width: 768px) {
  .AdminDashboard_dashboard__ywjs4 {
    padding: 1.5rem 1rem 4rem;
  }

  .AdminDashboard_header__lCQjd {
    flex-direction: column;
    text-align: center;
  }

  .AdminDashboard_headerText__1Cv5n h1 {
    font-size: 1.5rem;
  }

  .AdminDashboard_cards__DM79p {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 1024px) {
  .AdminDashboard_cards__DM79p {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminDashboard/AdminDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,WAAW;EACb;AACF","sourcesContent":[":root {\r\n  --brand: #4a6cf7;\r\n  --brand-dark: #3a59d0;\r\n  --bg-light: #f7f9fc;\r\n  --text: #1a1a2e;\r\n  --muted: #555;\r\n  --shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* === Контейнер === */\r\n.dashboard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background: var(--bg-light);\r\n  color: var(--text);\r\n  padding: 2rem 1.5rem 4rem;\r\n}\r\n\r\n/* === Заголовок === */\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  max-width: 1200px;\r\n  width: 100%;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.headerIcon {\r\n  font-size: 2.2rem;\r\n  color: var(--brand);\r\n  background-color: rgba(74, 108, 247, 0.1);\r\n  border-radius: 0.8rem;\r\n  padding: 0.7rem;\r\n}\r\n\r\n.headerText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left;\r\n}\r\n\r\n.headerText h1 {\r\n  font-size: 1.7rem;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.headerText p {\r\n  color: var(--muted);\r\n  margin: 0.2rem 0 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* === Секции === */\r\n.section {\r\n  width: 100%;\r\n  max-width: 1300px;\r\n  margin: 0 auto 2.5rem;\r\n}\r\n\r\n.sectionTitle {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--brand);\r\n  margin-bottom: 1.2rem;\r\n  text-align: left;\r\n}\r\n\r\n/* === Сетка карточек === */\r\n.cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n/* === Карточка === */\r\n.card {\r\n  background: #fff;\r\n  border-radius: 0.8rem;\r\n  padding: 1rem 1.2rem;\r\n  color: var(--text);\r\n  text-decoration: none;\r\n  box-shadow: var(--shadow);\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  min-height: 90px;\r\n  cursor: grab;\r\n}\r\n\r\n.card:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cardIcon {\r\n  font-size: 1.6rem;\r\n  color: var(--brand);\r\n  flex-shrink: 0;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.cardText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left;\r\n}\r\n\r\n.cardText h4 {\r\n  font-size: 1rem;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.desc {\r\n  font-size: 0.85rem;\r\n  color: var(--muted);\r\n  margin-top: 0.3rem;\r\n  line-height: 1.3;\r\n}\r\n\r\n/* === Пустой раздел === */\r\n.empty {\r\n  text-align: center;\r\n  color: var(--muted);\r\n  padding: 2rem;\r\n  font-size: 0.95rem;\r\n  background: rgba(255, 255, 255, 0.6);\r\n  border-radius: 0.8rem;\r\n  border: 1px dashed rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* === Адаптив === */\r\n@media (max-width: 768px) {\r\n  .dashboard {\r\n    padding: 1.5rem 1rem 4rem;\r\n  }\r\n\r\n  .header {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .headerText h1 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .cards {\r\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n    gap: 1.2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `AdminDashboard_dashboard__ywjs4`,
	"header": `AdminDashboard_header__lCQjd`,
	"headerIcon": `AdminDashboard_headerIcon__6DkZW`,
	"headerText": `AdminDashboard_headerText__1Cv5n`,
	"section": `AdminDashboard_section__ZSL7z`,
	"sectionTitle": `AdminDashboard_sectionTitle__bEb5h`,
	"cards": `AdminDashboard_cards__DM79p`,
	"card": `AdminDashboard_card__czI3p`,
	"cardIcon": `AdminDashboard_cardIcon__tF6Ro`,
	"cardText": `AdminDashboard_cardText__Miycl`,
	"desc": `AdminDashboard_desc__4vOmv`,
	"empty": `AdminDashboard_empty__ALdQz`
};
export default ___CSS_LOADER_EXPORT___;
